export default class ApiClientRequest {
	url: string;

	options: { [key: string]: any };

	constructor(url: string, options: { [key: string]: any }) {
		this.url = url;
		this.options = options;
	}
}
